import React from 'react';
import { Redirect } from 'react-router-dom';
import { LayoutSplashScreen } from '../../../_metronic/layout/_core/MetronicSplashScreen';
import { OnboardingCreditsPollingLoader } from './OnboardingCreditsPollingLoader';

export type OnboardingStepStatus =
  | 'loading'
  | 'ready'
  | 'completed'
  | 'ineligible'
  | 'prior_pending';

interface OnboardingStepGateProps {
  status: OnboardingStepStatus;
  stepPath: string;
  children: React.ReactNode;
  isPollingCredits?: boolean;
  isExempt?: boolean;
}

export function OnboardingStepGate({
  status,
  stepPath,
  children,
  isPollingCredits = false,
  isExempt = false,
}: OnboardingStepGateProps) {
  if (isExempt) {
    return <>{children}</>;
  }

  if (status === 'loading') {
    if (isPollingCredits) {
      return <OnboardingCreditsPollingLoader />;
    }

    // Splash em qualquer rota autenticada enquanto a elegibilidade resolve.
    // Passar `children` no loading permite flash do dashboard e, com gates
    // aninhados, o passo seguinte pode redirecionar antes do anterior (ex.:
    // perfil while OAB ainda carrega o pending).
    return <LayoutSplashScreen />;
  }

  if (status === 'ready') {
    return <Redirect to={stepPath} />;
  }

  // prior_pending / completed / ineligible: deixa o gate anterior (ou a app) decidir.
  return <>{children}</>;
}

export default OnboardingStepGate;
